// Työmaapäiväkirjan tuntikirjausten ryhmittely ja kaluston muotoilu. Käytössä sekä merkintälomakkeella
// (SiteDaybookView) että työmaan päiväkirjalistalla (SiteView), jotta molemmat näyttävät saman jaon.

// Samassa järjestyksessä kuin tuntikirjausdialogin kirjauksen tyyppi.
export const CHARGE_TYPES = ['URAKKA', 'TUNTITYO', 'ODOTUS'];

// Lisätyö- ja odotusaikakirjaukset tulostuvat lisätietoineen asiakkaan päiväkirja-PDF:ään (tyomaa.hbs).
export const isPrintedToCustomer = chargeType => chargeType !== 'URAKKA';

// Tyypitön kirjaus on urakkaa (dialogin oletus). Tyhjät ryhmät jätetään pois.
export function groupTimeEntries(workers) {
  return CHARGE_TYPES.map(chargeType => ({
    chargeType,
    workers: (workers || []).filter(w =>
      chargeType === 'URAKKA' ? !['TUNTITYO', 'ODOTUS'].includes(w.entryChargeType) : w.entryChargeType === chargeType
    ),
  })).filter(group => group.workers.length > 0);
}

// Päivän kirjauksissa käytetty kalusto, kukin kerran.
export function uniqueEquipments(workers) {
  const seen = new Set();
  const result = [];
  for (const worker of workers || []) {
    for (const eq of worker.equipments || []) {
      if (!seen.has(eq.id)) {
        seen.add(eq.id);
        result.push(eq);
      }
    }
  }
  return result;
}

// Kaluston nimi ilman rekisterinumeroa, esim. "Huoltoauto, Sprinter".
export function equipmentName(eq) {
  return [eq.type && eq.type.name, eq.description].filter(Boolean).join(', ');
}
